module.exports = __webpack_public_path__ + "static/41-48eb8f2778f5490d0647143ed2eebb73.jpg";